import * as React from 'react';

import _ from 'lodash';

import ProgramMembershipsManager from 'bundles/internal-enterprise/components/ProgramMembershipsManager';
import Naptime from 'bundles/naptimejs';
import ProgramMembershipsV2 from 'bundles/naptimejs/resources/programMemberships.v2';

import 'css!./__styles__/EnterpriseToolsHome';

type Props = {
  params: { userId: string };
  programMemberships: Array<ProgramMembershipsV2>;
  location: { query: { email: string } };
  downgradedProgramMemberships: Array<ProgramMembershipsV2>;
};

type State = {
  emailVerified: boolean;
};

class ProgramManagerWithMemberships extends React.Component<Props, State> {
  constructor(props: $TSFixMe) {
    super(props);

    const { programMemberships } = props;
    this.state = {
      emailVerified:
        !programMemberships || !programMemberships.some((p: $TSFixMe) => p.membershipState.isEmailNotVerified),
    };
  }

  render() {
    const { programMemberships, params, location, downgradedProgramMemberships } = this.props;
    const extendedProgramMemberships = _.uniqBy(
      programMemberships.concat(...downgradedProgramMemberships),
      (membership) => membership.id
    );
    return (
      <div className="rc-ProgramManagerWithMemberships">
        {!this.state.emailVerified && (
          <h1 className="error-message">Warning: User email must be verified before joining a program.</h1>
        )}
        {programMemberships && (
          <ProgramMembershipsManager
            programMemberships={extendedProgramMemberships}
            userId={params.userId}
            email={location.query.email}
          />
        )}
      </div>
    );
  }
}

export default Naptime.createContainer(ProgramManagerWithMemberships, ({ params }) => ({
  downgradedProgramMemberships: ProgramMembershipsV2.finder('deletedMembershipsByUser', {
    params: {
      userId: params.userId,
    },
  }),
  programMemberships: ProgramMembershipsV2.finder('byUser', {
    params: { userId: params.userId },
    includes: ['programs'],
    fields: ['rosterIds'],
  }),
}));
